/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  console.log(list, "listlist")
  const [loader, setLoader] = useState(true)

  const getAppTypes = async () => {
    const { response } = await AppService.exchangepodcast.get({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.exchangepodcast.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Title', accessor: 'title' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'transcript', accessor: 'transcript' },
        { Header: 'video', accessor: 'video' },


        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        title: data.title ? `${data.title.substring(0,20)}...` : "",
        description: data.description 
    ? `${data.description.replace(/<[^>]+>/g, "").substring(0, 50)}...` 
    : "",
        transcript: data.transcript ? `${data.transcript.substring(0,20)}...` : "",
        video: data.video,

        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
